// extracted by mini-css-extract-plugin
module.exports = {"videoError":"video-player-modulevideoError31Y"};